<template>
  <transition name="modal">
    <portal to="destination">
      <div class="modal-backdrop z-20" v-show="show" @click.self="$emit('close')">
        <div class="relative modal flex justify-center flex-col font-mediumBig p-auto text-xm px-4 pt-10 pb-8" v-if="thank_type==='reg'">
          <button class="absolute pin-t pin-r outline-none m-6 mt-3 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <p class="text-main-text font-semibold text-center">
            <span class="text-brand-light">{{userData.name}}</span>, команда <span class="text-brand-light">{{teamName}}</span> <br>
            успешно зарегистрирована!
          </p>
          <br>
          <div class="font-normal text-center">
            <p>Ждём вас {{getEventDate}} в {{getEventTime}} в {{event.place}}</p>
            <p>по адресу {{event.address}}</p>
            <br>
            <p v-if="woPay && !isGameFree">Оплатить участие вы сможете на игре.</p>
            <p v-else-if="!isGameFree">Мы свяжемся с вами для уточнения способа<br> оплаты участия.</p>
          </div>


        </div>
        <div class="relative modal flex justify-center text-center flex-col -font-normal p-auto text-xm py-8 text-main-text" v-if="thank_type==='res'">
          <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <p class="font-semibold"><span class="text-brand-light font-bold">{{userData.name}}</span>, вы успешно<br class="xl:hidden lg:hidden"> записались<br class="hide-element">
          в резерв!</p>
          <br>
          <div class="px-8">
            <p>Организаторы свяжутся с вами, если<br class="md:hidden  xl:hidden lg:hidden"> место<br class="hide-element"> освободится. Дождитесь<br class="md:hidden  xl:hidden lg:hidden"> уведомления.</p>

          </div>


        </div>
        <div class="relative modal flex justify-center text-center flex-col -font-normal p-auto text-xm py-8" v-if="thank_type==='change'">
          <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
            <img class="h-4" src="@/assets/SVG/cross-partners.svg" />
          </button>
          <p class="font-semibold text-main-text"><span class="text-brand-light font-bold">{{userData.name}}</span>, изменения сохранены.</p>
          <br>
          <div class="px-8">
            <p>Увидимся на игре!</p>
          </div>


        </div>

      </div>
    </portal>
  </transition>
</template>

<script>
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';

export default {
  props: ['event', 'woPay', 'thank_type', 'isGameFree'],
  name: 'ThankYou',
  data() {
    return {
      ext: '',
      show: true,
    };
  },
  methods: {
    dismiss() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
      return this.show === false;
    },
  },
  created() {
    document.body.style.overflow = 'hidden';
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
      this.dismiss();
    });
  },


  computed: {
    getEventDate() {
      return format(parse(this.event.played_at), 'DD MMMM', { locale: ru });
    },

    getEventTime() {
      return format(parse(this.event.played_at), 'HH:mm', { locale: ru });
    },

    userData() {
      return this.$store.state.auth.user;
    },

    teamName: {
      cache: false,
      get() {
        const team = this.userData.applications.find(item => item.games_event_day_id === this.event.uuid);
        if (!team) return '';
        const teamId = this.userData.applications.find(item => item.games_event_day_id === this.event.uuid).team_id;
        const userTeam = this.userData.teams.find(item => item.id === parseInt(teamId));
        if (!userTeam) return '2';
        return userTeam.name;
      },
    },
  },
};

</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        padding: 1rem;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .modal {
        max-width: 27rem;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 5px 15px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        background-color: #ffffff;
    }

    @media (max-width: 767px) {
        .hide-element {
            display: none;
        }
    }

</style>
